module.exports = __webpack_public_path__ + "static/2_SINGLE-d734f97fa3c3bac8b043b64395242cbe.png";